import React from 'react';
import './PublicServices.css';

const PublicServices = () => {
  return (
    <div className="public-services">
      <div className="public-services-wrapper">
        <h2 className="public-services-title">🛎️ Public Services</h2>
        <p className="public-services-intro">
          Igbo-Eze North Local Government Council is committed to delivering essential services that improve lives and empower communities. Through our various departments and development centres, we provide accessible, transparent, and people-focused public services across key sectors.
        </p>

        <section className="public-service-section">
          <h3>🏥 Health Services</h3>
          <ul>
            <li>Primary healthcare at 38 PHCs and one General Hospital</li>
            <li>Free immunization campaigns for children under 5</li>
            <li>Maternal and child health programmes</li>
            <li>Community-based health insurance enrollment</li>
            <li>Sanitation and hygiene campaigns in schools and communities</li>
          </ul>
        </section>

        <section className="public-service-section">
          <h3>🏫 Education & Human Capital</h3>
          <ul>
            <li>Oversight and support for public primary and secondary schools</li>
            <li>Distribution of learning materials and student scholarships</li>
            <li>Vocational training programmes in trades and crafts</li>
            <li>Special support for orphans, girls, and vulnerable children</li>
            <li>Adult education and literacy initiatives (reviving under the MTDP)</li>
          </ul>
        </section>

        <section className="public-service-section">
          <h3>🌾 Agricultural Services</h3>
          <ul>
            <li>Provision of improved seedlings, fertilizers, and extension services</li>
            <li>Farmer training on climate-smart techniques and value addition</li>
            <li>Support for cooperative societies and youth-led farming projects</li>
            <li>Access to small farm estates and agro-processing hubs</li>
          </ul>
        </section>

        <section className="public-service-section">
          <h3>🚧 Infrastructure & Community Development</h3>
          <ul>
            <li>Road grading and rehabilitation for inter-community access</li>
            <li>Borehole drilling and water project maintenance</li>
            <li>Installation of solar streetlights and rural electrification support</li>
            <li>Waste management and environmental sanitation campaigns</li>
          </ul>
        </section>

        <section className="public-service-section">
          <h3>📄 Administrative Services</h3>
          <ul>
            <li>Birth, death, and marriage registration</li>
            <li>Issuance of permits (e.g., building, event, business)</li>
            <li>Tax payment and license renewal</li>
            <li>Access to the Local Government Secretariat and Development Centres</li>
          </ul>
        </section>

        <section className="public-service-section">
          <h3>🛍️ Market and Trade Services</h3>
          <ul>
            <li>Allocation of shops/stalls in major markets</li>
            <li>Market sanitation, fencing, and infrastructure upgrades</li>
            <li>Support for market-based cooperatives and women-led businesses</li>
          </ul>
        </section>

        <section className="public-service-section">
          <h3>🛡️ Security & Social Protection</h3>
          <ul>
            <li>Neighborhood Watch and Forest Guard services</li>
            <li>Public safety and conflict mediation in partnership with traditional rulers</li>
            <li>Support for women and girls facing gender-based violence</li>
            <li>Legal aid and mental health support for vulnerable populations</li>
            <li>Financial assistance and social pensions for the elderly and poor households</li>
          </ul>
        </section>

        <p className="public-services-conclusion">
          Need assistance with any of these services? Visit your nearest Development Centre or the Council Secretariat at Ogrute, or reach out via the <strong>Contact</strong> page for more information. 📞 Your well-being is our priority. We are here to serve you.
        </p>
      </div>
    </div>
  );
};

export default PublicServices;